//Creates new Tip Box and assigns ID and type
export const createMicrocentrifuge = (data) => {
    //data = {id, type}
    return { type: "CREATE_MICROCENTRIFUGE", payload: data}
}
export const toggleMicrocentrifugeLid = (data) => {
  return { type: "MICROCENTRIFUGE_TOGGLE_LID_STATE", payload: data}
}


export const toggleMicrocentrifugeControlsModal = (data) => {
  return { type: "MICROCENTRIFUGE_TOGGLE_CONTROLS_MODAL", payload: data}
}
export const toggleMicrocentrifugeTooltipsControls = (data) => {
  return { type: "MICROCENTRIFUGE_TOGGLE_TOOLTIP_CONTROLS", payload: data}
}
export const toggleMicrocentrifugeBalanceTubeModal= (data) => {
  return { type: "MICROCENTRIFUGE_TOGGLE_BALANCE_TUBE_MODAL", payload: data}
}
export const setMicrocentrifugeRPM = (data) => {
  return { type: "MICROCENTRIFUGE_UPDATE_RPM", payload: data}
}
export const setMicrocentrifugeTime = (data) => {
  return { type: "MICROCENTRIFUGE_UPDATE_TIME", payload: data}
}
export const ejectMicrocentrifugeTubes = (data) => {
  return { type: "MICROCENTRIFUGE_EJECT_TUBES", payload: data}
}
export const ejectMicrocentrifugeRotors = (data) => {
  return { type: "MICROCENTRIFUGE_EJECT_ROTORS", payload: data}
}
export const onMicrocentrifugeTubeDrop = (data) => {
  return { type: "MICROCENTRIFUGE_TUBE_DROP", payload: data}
}
export const checkMicrocentrifugeBalance = (data) => {
  return { type: "MICROCENTRIFUGE_SET_TUBES_BALANCED", payload: data}
}
export const onMicrocentrifugeInsertItem = (data) => {
  return { type: "MICROCENTRIFUGE_INSERT_ITEM" , payload: data}
}
export const onMicrocentrifugeInsertRotor = (data) => {
  return { type: "MICROCENTRIFUGE_INSERT_ROTOR" , payload: data}
}
export const onMicrocentrifugeRun = (data) => {
  return { type: "MICROCENTRIFUGE_RUN" , payload: data}
}
